<template>
  <header
    :class="headerClass"
    class="header"
  >
    <div
      class="header__logo-container"
    >
      <svg class="header__logo">
        <use xlink:href="/images/unm-logo.svg#unm-logo"/>
      </svg>
    </div>
    <div
      v-if="hud"
      class="header__hud"
    >
      <transition name="slide-question">
        <span
          :key="hud.top"
          class="header__hud-top label"
          v-text="hud.top"
        />
      </transition>
      <transition name="slide-question">
        <span
          :key="hud.bottom"
          class="header__hud-bottom number number-large"
          v-text="hud.bottom"
        />
      </transition>
    </div>
    <transition name="slide">
      <button
        v-if="menuEnabled"
        :class="menuClass"
        class="menu__button"
        @click="toggleResults"
      >
        <span class="menu__bar-wrapper">
          <span class="menu__bar-top">
            <span class="menu__crust menu__crust-top"/>
          </span>
          <span class="menu__bar-bottom">
            <span class="menu__crust menu__crust-bottom"/>
          </span>
        </span>
        <span
          v-if="!stage.results"
          class="menu__label choice"
          v-text="stage === 'results' ? 'Close' : 'Menu'"
        />
      </button>
      <span
        v-else
        :key="title"
        class="label header__label"
        v-text="title"
      />
    </transition>
  </header>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    name: 'TheHeader',
    computed: {
      headerClass() {
        return `header_${this.stage}`;
      },
      menuClass() {
        return {
          'show-tutorial': this.showTutorial,
        };
      },
      ...mapState([
        'title',
        'hud',
        'stage',
        'menuEnabled',
        'showTutorial',
      ]),
    },
    methods: {
      toggleResults() {
        if (this.showTutorial) {
          this.setWillHideTutorial(true);
        }

        this.toggleMenu();
      },
      ...mapMutations(['toggleMenu', 'setWillHideTutorial']),
    },
  };
</script>

<style lang="scss">
$header-margin-large: 65px;
$header-margin-small: 20px;

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.slide-enter {
  transform: translateY(100%);
}

.slide-leave-to {
  transform: translateY(-100%);
}

.slide-leave-active {
  position: absolute;
  right: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition-duration: $transition-duration;
  transition-property: opacity, transform;
  transition-timing-function: $transition-timing-function;
}

// This is for the question to menu toggle (middle of header)

.slide-question-enter,
.slide-question-leave-to {
  opacity: 0;
}

.slide-question-enter {
  transform: translateY(100%);
}

.slide-question-leave-to {
  transform: translateY(-100%);
}

.slide-question-leave-active {
  position: absolute;
  left: 0;
  right: 0;
}

.slide-question-enter-active,
.slide-question-leave-active {
  transition-duration: $transition-duration;
  transition-property: opacity, transform;
  transition-timing-function: $transition-timing-function;
}

.header_answer {
  .header__logo {
    fill: $cherry;

    @include breakpoint(large) {
      fill: $white;
    }
  }
}

.header_question {

  .header__label {
    color: $cherry;
  }

  .header__logo {
    fill: $cherry;
  }
}

.header_results,
.header_end {

  .header__hud {
    color: $white;
  }

  &.menu__button {
    color: $white;
  }

  .menu__label {
    color: $white;
  }

  .menu__bar-top {
    transform: rotate(60deg);
  }

  .menu__bar-bottom {
    transform: rotate(-60deg);
  }

  .menu__bar-wrapper {
    transition: transform $stage-transition-duration $menu-transition-timing-function;
    transform: rotate(90deg);
  }

  .menu__crust-top,
  .menu__crust-bottom {
      transform: translateY(0);
  }

  .menu__crust {
    background-color: $saudia-sunset;
  }
}

.header {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: $header_height-small;

  @include breakpoint(medium) {
    height: $header_height-medium;
  }

  @include breakpoint(large) {
    height: $header_height-large;
  }
}


.header__logo-container {
  @include z-index(header);
  position: absolute;
  left: $header-margin-small;
  display: block;

  @include breakpoint(large) {
    left: $header-margin-large;
  }
}

.header__logo {
  display: block;
  height: 50px;
  width: 50px;
  transition-duration: $stage-transition-duration;
  transition-property: fill;
  transition-timing-function: $transition-timing-function;
  fill: $white;
}

.header__title {
  transition-duration: $stage-transition-duration;
  transition-timing-function: $transition-timing-function;
}

.header__hud {
  @include z-index(header);
  position: absolute;
  width: 100%;
  left: 0;
  color: $turquoise;
  transition-duration: $stage-transition-duration;
  transition-property: color;
  transition-timing-function: $transition-timing-function;
}

.hud_results {
  color: $white;
}

.header__hud-top,
.header__hud-bottom {
  display: block;
  text-align: center;
}

.header_results,
.header_end {

  .header__label {
    max-width: 75px;
    text-align: right;

    @include breakpoint(medium) {
      max-width: 100%;
      text-align: left;
    }
  }
}

.header__label {
  @include z-index(header);
  display: inline-block;
  color: $white;
}

.header__label,
.menu__button {
  position: absolute;
  right: $header-margin-small;

  @include breakpoint(large) {
    right: $header-margin-large;
  }
}

.menu__button {
  position: absolute;
  right: $header-margin-small - 10px;

  @include breakpoint(large) {
    right: $header-margin-large - 10px;
  }
}

.menu__button {
  @include z-index(menu);
  color: $cherry;
  padding: 0 10px 10px;
  background-color: transparent;
  transition:
      color $stage-transition-duration $transition-timing-function,
      background-color $stage-transition-duration $transition-timing-function;
  outline: 0;

  .menu__label {

    @include breakpoint(large) {
      transition: transform $cta-transition-duration $cta-transition-timing-function;
      transform: scale(1);
    }

    &:hover,
    &:focus,
    &:active {

      @include breakpoint(large) {
        transition: transform $cta-transition-duration $cta-transition-timing-function;
        transform: scale(1.05);
      }
    }
  }

  &.show-tutorial {
    background-color: $cherry;
    color: $white;

    .menu__crust {
        background-color: $white;
      }
  }
}

.menu__bar-wrapper {
  position: relative;
  display: block;
  margin: 0 auto;
  width: $menu-button-size;
  height: $menu-button-size;
  cursor: pointer;
  transition: transform $stage-transition-duration $menu-transition-timing-function;
  transform: rotate(0deg);
  -webkit-tap-highlight-color: transparent;
}

.menu__bar-top,
.menu__bar-bottom {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: $menu-button-size;
  height: $menu-button-size;
  transition: transform $transition-duration/2 $menu-transition-timing-function;
  transform: rotate(0deg);
}

.menu__crust {
    display: block;
    width: $menu-bread-width;
    height: $menu-bread-height;
    background: $cherry;
    position: absolute;
    left: ($menu-button-size - $menu-bread-width) / 2;
    transition:
      transform $transition-duration/2 $menu-transition-timing-function,
      background $transition-duration/2 $transition-timing-function;
}

.menu__crust-top {
    top: ($menu-button-size - $menu-bread-height) / 2;
    transform: translateY(-3px);
}

.menu__label {
  display: block;
  margin-top: -15px;
}

.menu__crust-bottom {
  bottom: ($menu-button-size - $menu-bread-height) / 2;
  transform: translateY(3px);
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue